module.exports = __webpack_public_path__ + "static/connection_scheme-8cb386bd4c6e3150e39c8ecfd939e1a3.jpg";